import React from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import { TOGGLE_SUBS_CART } from "utils/action-types";
import { isMobile } from "utils/device-detect";

const useSaveToast = (callback) => {
	const { pendingChanges, totalWeight } = useSelector(state => state.account.subscription);
	const { translation, cartSettings } = useGlobalContext();
	const dispatch = useDispatch();
	const isMobileView = isMobile();

	const showToast = (force = false) => {
		const handleClick = () => {
			!isMobileView && dispatch({ type: TOGGLE_SUBS_CART });
			callback && callback();
		};

		if ((pendingChanges || force) && totalWeight > cartSettings.min_products_required) {
			toast.dark(
				<button className="size-full text-left" onClick={handleClick}>
					{translation?.subscription?.save_changes_message}
				</button>,
				{ autoClose: false, toastId: "toast", className: "save-changes-toast", closeButton: false }
			);
		}
	};

	return showToast;
};

export default useSaveToast;